<template>
  <div class="login-firstTime">
    <div id="page-content-wrapper">
      <div class="container-fluid">
        <div class="row">
          <!-- Without CMS -->
          <div v-if="isCmsUsed === false" class="col-md-7 loginLeft">
            <img src="assets/images/login-graphic.png" alt="" />
          </div>

          <!-- With CMS -->
          <div
            v-if="isCmsUsed === true"
            class="col-md-7 loginLeft"
            v-html="leftContent"
          ></div>

          <div class="col-md-5 loginRight">
            <div class="loginWrapper">
              <div class="logo">
                <!--<img src="assets/images/logo.png" alt="" />-->
                <img src="brand-logo.png" alt="" />
              </div>

              <!-- Without CMS -->
              <div v-if="isCmsUsed === false" class="loginText">
                <h1>Reward card solutions to help everyone earn more</h1>
                <p>
                  With our prepaid cards accepted in over 30 Million places
                  <br />around the world...
                </p>
              </div>

              <!-- With CMS -->
              <div
                v-if="isCmsUsed === true"
                class="loginText"
                v-html="rightContent"
              ></div>
              <div class="loginControls">
                <ul class="nav nav-pills">
                  <li>
                    <a
                      href="#login"
                      data-toggle="tab"
                      v-on:click="handleClick"
                      class="active"
                      >Login</a
                    >
                  </li>
                  <span class="pillSpacer"></span>
                  <li>
                    <a
                      href="#firsttime"
                      data-toggle="tab"
                      v-on:click="handleClick"
                      >First Time Login</a
                    >
                  </li>
                </ul>

                <div class="tab-content clearfix">
                  <div class="tab-pane active" id="login">
                    <validation-observer ref="loginObserver">
                      <form action="form" @submit.prevent="authenticate">
                        <validation-provider
                          v-slot="{ errors }"
                          name="Email"
                          rules="required|email"
                        >
                          <input
                            type="text"
                            id="emailphone"
                            name="emailphone"
                            placeholder="Email address"
                            v-model="email"
                            autocomplete="username"
                          />
                          <div class="error">{{ errors[0] }}</div>
                        </validation-provider>
                        <br />
                        <validation-provider
                          v-slot="{ errors }"
                          name="Password"
                          rules="required|min:8"
                        >
                          <input
                            name="password"
                            class="password"
                            type="password"
                            placeholder="Password"
                            v-model="password"
                            autocomplete="current-password"
                          />
                          <div class="error">{{ errors[0] }}</div>
                        </validation-provider>
                        <button
                          v-if="isLoginButtonLoading === true"
                          type="submit"
                          disabled
                        >
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Logging in...
                        </button>
                        <button
                          v-if="isLoginButtonLoading === false"
                          type="submit"
                        >
                          Login
                        </button>
                        <router-link
                          v-bind:to="resetPasswordRoute"
                          class="resetPassword"
                          >Forgot your password?</router-link
                        >
                      </form>
                    </validation-observer>
                  </div>
                  <div class="tab-pane" id="firsttime">
                    <validation-observer ref="registrationObserver">
                      <form action="form" @submit.prevent="registerCard">
                        <validation-provider
                          v-slot="{ errors }"
                          name="Card number"
                          rules="required|min:9"
                        >
                          <input
                            id="ccn"
                            type="tel"
                            inputmode="numeric"
                            autocomplete="cc-number"
                            maxlength="9"
                            placeholder="9 Digit number on your card"
                            v-model.number="cardNumber"
                          />
                          <div class="error">{{ errors[0] }}</div>
                        </validation-provider>

                        <br />
                        <span>Expiry date:</span>
                        <select class="monthSelect" v-model="selectedMonth">
                          <option>01 </option>
                          <option>02 </option>
                          <option>03 </option>
                          <option>04 </option>
                          <option>05 </option>
                          <option>06 </option>
                          <option>07 </option>
                          <option>08 </option>
                          <option>09 </option>
                          <option>10 </option>
                          <option>11 </option>
                          <option>12 </option>
                        </select>
                        <select class="yearSelect" v-model="selectedYear">
                          <option>{{ currentYear }} </option>
                          <option>{{ currentYear + 1 }} </option>
                          <option>{{ currentYear + 2 }} </option>
                          <option>{{ currentYear + 3 }} </option>
                          <option>{{ currentYear + 4 }} </option>
                          <option>{{ currentYear + 5 }} </option>
                        </select>
                        <br />
                        <input
                          type="text"
                          placeholder="Email address"
                          id="login"
                          v-model="emailReg"
                        />
                        <br /><br />
                        <input
                          type="password"
                          placeholder="Password"
                          id="password"
                          v-model="passwordReg"
                        />
                        <br /><br />
                        <div class="triggers">
                          <div class="terms">
                            <div class="trigger">
                              <input
                                type="checkbox"
                                id="terms-checkbox"
                                v-model="termsAccepted"
                              />
                              <label id="button" for="terms-checkbox">
                                <div id="knob"></div>
                                <div id="subscribe">YES</div>
                                <div id="alright">NO</div>
                              </label>
                            </div>
                            <span
                              >I have read and accept the
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#termsAndConditions"
                                >Terms &amp; Conditions</a
                              >
                              and
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#feesAndLimits"
                                >Fees &amp; Limits</a
                              >.</span
                            >
                          </div>
                        </div>
                        <button
                          v-if="isRegistrationProceedButtonLoading === true"
                          type="submit"
                          disabled
                        >
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Registering...
                        </button>
                        <button
                          v-if="isRegistrationProceedButtonLoading === false"
                          type="submit"
                          :disabled="disabled"
                        >
                          Register
                        </button>
                      </form>
                    </validation-observer>

                    <div
                      class="modal fade"
                      id="termsAndConditions"
                      tabindex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalCenterTitle"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-body">
                            <TermsAndConditions />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="modal fade"
                      id="feesAndLimits"
                      tabindex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalCenterTitle"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-body">
                            <FeesAndLimits />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actions from "@/store/authentication/actions";
import { required, email, max, min } from "vee-validate/dist/rules";
import { extend, setInteractionMode } from "vee-validate";
import routes from "@/constants/routes";
import TermsAndConditions from "./TermsConditions.vue";
import FeesAndLimits from "./FeesAndLimits.vue";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} can not be empty"
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters"
});

extend("min", {
  ...min,
  message: "{_field_} must be greater than {length} characters"
});

extend("email", {
  ...email,
  message: "Email must be valid"
});

export default {
  components: {
    TermsAndConditions,
    FeesAndLimits
  },
  data: () => ({
    selectedYear: new Date().getFullYear(),
    selectedMonth: "01",
    currentYear: new Date().getFullYear(),
    cardNumber: null,
    email: "",
    password: "",
    emailReg: "",
    passwordReg: "",
    termsAccepted: false
  }),
  created() {
    this.resetPasswordRoute = routes.FORGOTTENPASS;
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
    this.rightContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.rightContent != null
        ? this.cmsPage.rightContent
        : "";
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    },
    isLoginButtonLoading: {
      get() {
        return this.$store.state.settings.isLoginButtonLoading;
      },
      set(value) {
        this.$store.commit("updateIsLoginButtonLoadingMutation", value);
      }
    },
    isRegistrationProceedButtonLoading: {
      get() {
        return this.$store.state.settings.isRegistrationProceedButtonLoading;
      },
      set(value) {
        this.$store.commit(
          "updateIsRegistrationProceedButtonLoadingMutation",
          value
        );
      }
    },
    disabled() {
      return !this.termsAccepted;
    }
  },
  methods: {
    handleClick() {
      this.$refs.registrationObserver?.reset();
      this.$refs.loginObserver?.reset();
    },

    authenticate: function() {
      this.$refs.loginObserver.validate().then(valid => {
        if (valid) {
          this.isLoginButtonLoading = true;
          const formedPayload = {
            email: this.email,
            password: this.password
          };

          this.$store.dispatch(actions.LOGIN, formedPayload);
        }
      });
    },

    registerCard: function() {
      this.$refs.registrationObserver.validate().then(valid => {
        if (valid) {
          this.isRegistrationProceedButtonLoading = true;
          const expiryDate = `${this.selectedYear}-${this.selectedMonth}-01`;
          const cardPayload = {
            cardNumber: this.cardNumber,
            cardExpirationDate: expiryDate,
            email: this.emailReg,
            password: this.passwordReg
          };

          this.$store.dispatch(actions.REGISTER, cardPayload);
        }
      });
    }
  }
};
</script>
